import { analyticsMarketplaceService } from '~/api/service/analytics/marketplace.service'
import { analyticsNetworkService } from '~/api/service/analytics/network.service'
import { analyticsTokenService } from '~/api/service/analytics/token.service'
import { analyticsUserService } from '~/api/service/analytics/user.service'
import { analyticsPageTab } from '~/routes/analytics'
import { IAnalyticsChartInfoOption, IAnalyticsInterval, IAnalyticsPeriod } from '~/types/analytics.type'
import { ITab } from '~/types/tab.type'

export const ANALYTICS_TAB_LIST: Array<ITab<string>> = [
  {
    value: analyticsPageTab.user,
    label: 'User'
  },
  {
    value: analyticsPageTab.network,
    label: 'Network'
  },
  {
    value: analyticsPageTab.token,
    label: 'Token'
  },
  {
    value: analyticsPageTab.marketplace,
    label: 'Marketplace'
  }
]

export const ANALYTICS_PERIOD_LIST: Array<ITab<IAnalyticsPeriod>> = [
  { value: IAnalyticsPeriod.D7, label: '7D' },
  { value: IAnalyticsPeriod.M1, label: '1M' },
  { value: IAnalyticsPeriod.M6, label: '6M' },
  { value: IAnalyticsPeriod.YTD, label: 'YTD' },
  { value: IAnalyticsPeriod.Y1, label: '1Y' },
  { value: IAnalyticsPeriod.ALL, label: 'Max' },
  { value: IAnalyticsPeriod.SELECTOR, label: '', leftIcon: 'calendar' }
]

export const ANALYTICS_INTERVAL_LABEL = {
  [IAnalyticsInterval.DAY]: 'Daily',
  [IAnalyticsInterval.WEEK]: 'Weekly',
  [IAnalyticsInterval.MONTH]: 'Monthly',
}

export const ANALYTICS_INTERVAL_LIST = Object.entries(ANALYTICS_INTERVAL_LABEL).map(([ key, value ]) => {
  return {
    value: key,
    label: value,
  }
})


export const ANALYTICS_CHART_API: Record<string, IAnalyticsChartInfoOption> = {
  'user-msu-unique-active-wallets': {
    api: analyticsUserService.useGetMsuUniqueActiveWallets,
    intervalList: ANALYTICS_INTERVAL_LIST,
  },
  'user-msu-new-registered-users': {
    api: analyticsUserService.useGetNewRegisteredUsers,
  },
  'user-msu-total-users': {
    api: analyticsUserService.useGetTotalUsers,
  },
  'user-msu-retention-rate': {
    api: analyticsUserService.useGetRetentionRate,
    singleSelect: true,
    yMax: 100,
    yTickAmount: 6,
    unit: '%',
  },
  'user-msu-stickness': {
    api: analyticsUserService.useGetUserStickiness,
    yTickAmount: 6,
    yMax: 100,
    unit: '%',
  },
  'user-msn-unique-active-wallets': {
    api: analyticsUserService.useGetMsnUniqueActiveWallets
  },
  'user-msn-unique-active-address': {
    api: analyticsUserService.useGetUniqueActiveAddresses
  },
  'network-transaction-count': {
    api: analyticsNetworkService.useGetTransactionCount
  },
  'token-neso-holders': {
    api: analyticsTokenService.useGetNesoHolders
  },
  'token-nxpc-holders': {
    api: analyticsTokenService.useGetNxpcHolders
  },
  'token-nft-holders': {
    api: analyticsTokenService.useGetNftHolders
  },
  'marketplace-traders': {
    api: analyticsMarketplaceService.useGetMarketplaceTraders
  },
}